import React, { useContext } from 'react';
import './WatchFeedbackSurvey.scss';
import ApplicationContext from 'components/Application/Context';

type WatchFeedbackSurveyProps = {
  readonly watchSourceId: number;
  readonly benSourceId?: number;
  readonly placementId?: number;
  readonly productionId?: number;
};

function WatchFeedbackSurvey({
  watchSourceId,
  benSourceId,
  placementId,
  productionId,
}: WatchFeedbackSurveyProps) {
  const { postHog } = useContext(ApplicationContext);

  const triggerPostHogSurvey = () => {
    // the survey is set to show up after this event is captured
    postHog?.capture('viewership_feedback_survey_opened', {
      watchSourceId,
      benSourceId,
      placementId,
      productionId,
    });
  };

  return (
    <div className="feedback-survey-container">
      <button
        type="button"
        className="feedback-survey-button"
        onClick={triggerPostHogSurvey}
      >
        Did you not find all the data you were looking for? Let us know!
      </button>
    </div>
  );
}

export default WatchFeedbackSurvey;
